
    <div class="Customers customer-company ui-g">
      <div class="ui-g ui-fluid" style="width: 100%">
        <div class="ui-g-12"> <!-- [hidden]="isLoading" -->
          <div>
            <div class="ui-g ui-g-nopad form-group master-data">
              <div class="ui-g-12 ui-lg-8 ui-g-nopad">
                <h1 class="step-title">{{ titlePage | translate}}</h1>
              </div>
              <div class="ui-g-12 ui-lg-4 text-right">
                <button pButton type="button" class="k-generic-btn" icon="fa fa-angle-left" iconPos="left" label="Back" (click)="locationBack()"></button>
                <button pButton type="button" class="k-generic-btn" icon="fa fa-floppy-o" iconPos="left" label="{{ 'common.save' | translate }}" (click)="save()"></button>
              </div>
            </div>
          </div>
          <form *ngIf="formData" [formGroup]="formData">
            <div class="ui-g form-group master-data">
              <div [kv-form-element]="{ label: 'promotion.code', md: '6' }">
                <input type="text" pInputText formControlName="code" />
              </div>
              <div [kv-form-element]="{ label: 'promotion.description', md: '6' }">
                <input type="text" pInputText formControlName="description" />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
     


// WEBPACK FOOTER //
// ./src/app/views/promotion/discount-type/components/discountTypeDetail.component.ts.DiscountTypeDetailComponent.html